import { DesignProp, GeneralProp } from "../PropCategories";

export const borderStyle = {
  prop: "style-attribute",
  name: "Border style",
  nameI18n: "builder_ui.prop_type.border_style",
  type: "select",
  defaultValue: "solid",
  category: [DesignProp, GeneralProp],
  options: [
    {
      label: "Solid",
      labelI18n: "builder_ui.prop_type.styles.border_style_types.solid",
      value: "solid",
    },
    {
      label: "Dashed",
      labelI18n: "builder_ui.prop_type.styles.border_style_types.dashed",
      value: "dashed",
    },
    {
      label: "Dotted",
      labelI18n: "builder_ui.prop_type.styles.border_style_types.dotted",
      value: "dotted",
    },
    {
      label: "Inset",
      labelI18n: "builder_ui.prop_type.styles.border_style_types.inset",
      value: "inset",
    },
    {
      label: "Outset",
      labelI18n: "builder_ui.prop_type.styles.border_style_types.outset",
      value: "outset",
    },
  ],
} as const;
